export default __webpack_public_path__ + "static/assets/49e176447e37140da6f5bed7fd9eabaa.png";